import React, { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import QRCode from "react-qr-code";
import styled from "styled-components";

import { getTagFromResource } from "@examspark/common";
import {
  Button,
  Link,
  Modal,
  Toolbar,
  VSpace,
  Text,
} from "@examspark/common-ui";
import {
  IconCopySolid,
  IconQrCodeLine,
} from "@examspark/common-ui/dist/components/icons";
import { toast } from "@examspark/common-ui/dist/components/toast/Toast";
import { colorFromTheme } from "@examspark/common-ui/dist/utils/color";
import { Resource } from "@examspark/types";

import { getStudentDomain } from "../../util";

const StyledURL = styled.pre`
  border: solid 1px #ddd;
  min-height: 3rem;
  box-sizing: border-box;
  display: flex;
  padding: 0.5rem 0.5rem;
  align-items: center;
  border-radius: 0.5rem;
  overflow-x: auto;
  margin: 0;
  background-color: #fff;
  white-space: pre-wrap;
  line-height: 1.5em;

  a {
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    white-space: nowrap;
  }

  button {
    margin: -0.2rem;
    svg {
      fill: #777;
    }
  }
`;

const StyledCodes = styled.div`
  text-align: center;
  font-size: 5rem;
  color: ${colorFromTheme("text")};
  box-sizing: border-box;
  max-height: 100%;
  min-height: 0;
  overflow: auto;
  margin: auto;
  width: 100%;
  /* align-items: center; */
  /* justify-content: center; */
  /* margin: auto; */

  /* Flex container */
  & > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const StyledQRCode = styled.div`
  display: flex;
  justify-content: center;

  svg {
    --size: clamp(10rem, 30vw, 40rem);
    width: var(--size);
    height: var(--size);
  }
`;

const StyledDomain = styled.div`
  font-size: max(2vw, 1.5rem);
`;

const StyledAccessCode = styled.div`
  font-size: clamp(1.5rem, 15vw, 15rem);
`;

const ActivityKioskUrl = (props: { examConfig: Resource }) => {
  const { examConfig } = props;
  const [showCodes, setShowCodes] = useState(false);
  const [showAnonymous] = useState(true);
  const studentDomain = getStudentDomain();
  let url = `${studentDomain}`;

  const examConfigAccessCode = getTagFromResource(
    examConfig,
    "exam-ticket",
  )?.value;
  if (examConfigAccessCode && showAnonymous) {
    url += `?accessCode=${examConfigAccessCode}`;
  }

  return (
    <VSpace size="1rem">
      <Modal
        isOpen={showCodes}
        onRequestClose={() => setShowCodes(false)}
        size="mobile"
        title="Activity Access Codes"
        flexBodyColumn
      >
        <StyledCodes>
          <div>
            <VSpace>
              <StyledQRCode>
                <QRCode value={url} />
              </StyledQRCode>
              <StyledDomain>
                {studentDomain.replace(/^http?s:\/\//, "")}
              </StyledDomain>
              {showAnonymous && (
                <StyledAccessCode>
                  <div>{examConfigAccessCode}</div>
                </StyledAccessCode>
              )}
            </VSpace>
          </div>
        </StyledCodes>
      </Modal>
      <Text.Body>
        This assignment can be accessed using the URL below. You can also
        display a QR code for students to scan.
      </Text.Body>
      <Toolbar>
        <div style={{ flex: 1, minWidth: 0 }}>
          <StyledURL>
            <Link href={url} target="_blank">
              {url}
            </Link>
            <CopyToClipboard
              text={url}
              onCopy={() => {
                toast.success("Assignment URL has been copied to clipboard.");
              }}
            >
              <Button title="Copy" variant="plain" size="sm">
                <IconCopySolid width="12" />
              </Button>
            </CopyToClipboard>
          </StyledURL>
        </div>
        <div style={{ width: "8rem" }}>
          <StyledURL>
            <div style={{ flex: 1 }}>{examConfigAccessCode}</div>
            {examConfigAccessCode && (
              <CopyToClipboard
                text={examConfigAccessCode}
                onCopy={() => {
                  toast.success(
                    "Assignment Code has been copied to clipboard.",
                  );
                }}
              >
                <Button
                  title="Copy"
                  variant="plain"
                  size="sm"
                  // disabled={isCopied}
                >
                  <IconCopySolid width="10" />
                </Button>
              </CopyToClipboard>
            )}
          </StyledURL>
        </div>
        <Button
          title="Show Access Codes"
          onClick={() => setShowCodes(true)}
          icon={<IconQrCodeLine />}
        >
          Assignment Code
        </Button>
      </Toolbar>
    </VSpace>
  );
};

export default ActivityKioskUrl;
